import React, { useState, useEffect } from 'react';
import { sculpturesAPI } from '../lib/api';
import { VideoCard } from '../components/VideoCard';
import { Loader2 } from 'lucide-react';
import { SculpturesPageSEO } from '../components/SEO';

export const SculpturesPage = () => {
    const [sculptures, setSculptures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchSculptures = async () => {
            try {
                const response = await sculpturesAPI.getAll();
                // Handle paginated response
                setSculptures(response.data.data || response.data);
            } catch (err) {
                setError('Failed to load sculpture videos');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchSculptures();
    }, []);

    if (loading) {
        return (
            <>
                <SculpturesPageSEO />
                <div className="min-h-[50vh] flex items-center justify-center" data-testid="sculptures-loading">
                    <Loader2 className="h-8 w-8 animate-spin text-accent" />
                </div>
            </>
        );
    }

    return (
        <div className="section-gap" data-testid="sculptures-page">
            <SculpturesPageSEO />
            <div className="container-main">
                {/* Header */}
                <div className="mb-12">
                    <span className="text-xs font-semibold uppercase tracking-widest text-accent">
                        Figure sculpting instruction
                    </span>
                    <h1 className="font-serif text-4xl md:text-5xl font-semibold text-primary mt-2">
                        Sculpture Videos & Instruction
                    </h1>
                    <p className="text-muted-foreground mt-4 max-w-2xl">
                        Learn classical figure sculpting, portrait bust modeling, and clay techniques from expert sculptors 
                        through professional video demonstrations.
                    </p>
                </div>

                {error && (
                    <div className="text-center py-12" data-testid="sculptures-error">
                        <p className="text-destructive">{error}</p>
                    </div>
                )}

                {!error && sculptures.length === 0 && (
                    <div className="text-center py-12" data-testid="sculptures-empty">
                        <p className="text-muted-foreground">No sculpture videos available at this time.</p>
                    </div>
                )}

                {/* Sculpture Grid */}
                {sculptures.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="sculptures-grid">
                        {sculptures.map((sculpture) => (
                            <VideoCard 
                                key={sculpture.id} 
                                video={sculpture} 
                                type="sculpture" 
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SculpturesPage;
